import React, { useState, useEffect, useRef } from "react";
import { sms, transactionAPI, accountAPI } from "services";
import { Loader } from "components";
import { formatMoney } from "utils";
import { Colors, creatableStyle } from "assets/themes";
import txnaudio from "assets/sounds/google_pay-mini.mp3";
import FilePicker from "views/FilePicker";
import Creatable from "react-select/creatable";
import useUniversalStore from "store/universalStore";
import DateTimePicker from "react-datetime-picker";
import { toast } from "sonner";
import useOffcanvasStore from "store/offcanvasStore";
import { Controller, useForm } from "react-hook-form";
import { amountChangeHandler, defaultValues,formFields} from "./config"
import { stringSort } from "utils";

const OneTimeTxn = () => {
  const { accounts, accountId, profile, write } = useUniversalStore((state) => state);
  const { control, handleSubmit, setValue, formState: { errors, isSubmitting, isValid }, watch, clearErrors } = useForm({
      defaultValues,
      mode: 'onChange'
    });
  const { closeOffcanvas } = useOffcanvasStore();
  const accountName = watch("accountName");
  const phone = watch("phone");
  const attachment = watch("attachment");
  const notify = watch("notify");

  const [isKHATA, setIsKHATA] = useState(true);
  const [multipler, setMultipler] = useState(1);
  const [options, setOptions] = useState([]);

  // Populate account name and phone number when accountId change
  useEffect(() => {
    populateAccountName(accountId);
  }, [accountId]);

  // Populate accounts dropdown when accounts change
  useEffect(() => {
    const sortedAccounts = stringSort(accounts, false, "name");
  
    populateAccountsDropdown(sortedAccounts);
  }, [accounts]);

  // Function to populate account name and phone number
  const populateAccountName = (accountId) => {
    try {
      if (accountId) {
        const account = accounts.find((acc) => acc.id === accountId);
        setValue("accountName", account.get("name"))
        setValue("phone",account.get("phone"))
        setIsKHATA(true);
      }
      if (window.location.pathname === "/cashbook") {
          setIsKHATA(false)
          setValue("accountName", "")
          setValue("phone","")
      }  
    } catch (error) {
      console.log("Error while fetching account name",error);
    }
  };

  // Function to populate accounts dropdown
  const populateAccountsDropdown = (_accounts) => {
    const _options = [];
    for (var i = 0; i < _accounts.length; i++) {
      _options.push({
        value: _accounts[i].get("phone"),
        label: _accounts[i].get("name"),
      });
    }
    setOptions(_options);
    // This will be simpler...
    // setOptions(_accounts.map(tt=> { return {value: tt.get("phone"), label: tt.get("name")}}));
  };

  const amountChangeHandler = (e, onChange) => {
    e.preventDefault();
    
    // Extract numeric value from the input
    let numericValue = parseFloat(e.target.value.replace(/[^0-9.-]/g, "")) || 0;
    
    // Update the form value for amount
    if (numericValue === NaN || numericValue === "") {
      onChange(0);
    }
    onChange(numericValue);
  };

  // Handle the change when selecting contacts from the dropdown
  const accountChangeHandler = (selectedOption) => {
    // Handle the case when account name is cleared.
    if(!selectedOption) {
      setValue("accountName","")
      setValue("phone","")
      return;
    };
    
    setValue("accountName",selectedOption.label)
    setValue("phone", selectedOption.__isNew__ ? null :selectedOption.value)
  };

  // Check if phone number is available and set notify accordingly
  const checkNumber =  ()=>{
    // If phone number is not available, set notify to false
    if (!phone) setValue("notify",false);
    // If phone number is available, toggle notify
    else setValue("notify",!notify);
  }

  // Check phone number when accountNamechange
  useEffect(() => {
    console.log("accountName",accountName);
    checkNumber();
  }, [accountName]);

  // Handle change for notify checkbox
  const notifyChangeHandler = (e, onChange, value) => {
    console.log(value);
    //onChange(!value);
    
    checkNumber();
    
    if (accountName && !phone) {
      toast.error("Account does not have a phone number");
    } 
    if(!accountName){    
        toast.error("Select an account to notify")
    }
    
  };

  // Handle form submission
  const submitAddTransaction = async (data) => {
      console.log("data",data);
      try {
        const result = await transactionAPI.transaction(
          data.accountName,
          data.amount * multipler,
          data.detail,
          data.attachment.url,
          data.date
        );
        
        if(result){
          toast.success("Transaction done successfully.");
          closeOffcanvas();
          successaudio();
        }

        // Send SMS notification if phone number is available and notify is true
        if (result.get("accountId")?.get("phone") !== "" && notify) {
          const amount = result.get("amount");

          // TODO: Remove this hardcoded phone number
          const phone = "91" + result.get("accountId").get("phone");
          const partyName = profile?.get("businessName") ? profile.get("businessName") : profile.get("phone");

          if (result.get("amount") < 0) {
            sms.sendPaidSMS(Math.abs(amount), partyName, accountId, phone);
          } else {
            sms.sendReceiveSMS(Math.abs(amount), partyName, accountId, phone);
          }
        }

        const transactionDate = new Date(data.date);
        // Update transactions and accounts
        if (accountId && window.location.pathname !== "/cashbook") {          
          write({
            transactions: await transactionAPI.getTransactionsByAccountIdWithMonth(accountId, transactionDate),
            accounts: await accountAPI.getAccounts()
          });
        } else {
          write({
            transactions: await transactionAPI.getTransactionsByDate(transactionDate)
          });
        }

      } catch (error) {
        toast.error(error.message);
      }
  };

  // Play success audio
  const successaudio = async() => {
    var audio = new Audio(txnaudio);
    audio.play();
  };

  // Render form fields
  const renderField = (field) => {
    const commonProps = {
      placeholder: field.placeholder,
      className: `form-control ${errors[field.name] ? 'is-invalid' : ''}`
    };

    if (field.name === 'accountName' && !isKHATA) {
      return (
        <div className="mb-3" key={field.name}>
          <Controller
            name={field.name}
            control={control}
            rules={field.rules}
            render={({ field: { value, onChange } }) => (
              <>
                {field.name === 'accountName' && (
                  <Creatable
                    options={options}
                    value={value ? { label: value, value: watch('phone') } : null}
                    classNamePrefix="rs"
                    isClearable
                    placeholder={field.placeholder}
                    onChange={(selectedOption) => accountChangeHandler(selectedOption)}
                    styles={creatableStyle}
                  />
                )}
                {errors[field.name] && (
                  <div className="invalid-feedback d-block">
                    {errors[field.name].message}
                  </div>
                )}
              </>
            )}
          />
        </div>
      );
    }

    // if the field is not account name
    return (
      <div className={field.name === "amount" || field.name === "date" ?"mb-3 col-6":"mb-3"} key={field.name}>
          {["amount", "date", "detail"].includes(field.name) && <label className="text-app" style={{fontSize: "0.75rem"}}>
            {field.name.charAt(0).toUpperCase() + field.name.slice(1)}
          </label>}
        <Controller
          name={field.name}
          control={control}
          rules={
            field.name === "notify" ?
            {
              ...field.rules,
              validate : (value) => field.rules.validate( value, setValue, accountName, phone )
            }
            : field.rules
          }
          render={({ field: { value, onChange, ...fieldProps } }) => {
            // if(errors) console.log("errors : ",errors);
            switch (field.type) {
              case 'date':
                return (
                  <DateTimePicker
                    className="p-2"
                    calendarIcon={<i className="bi bi-calendar-date fs-5"></i>}
                    clearIcon={null}
                    maxDate={new Date()}
                    disableClock={true}
                    format="dd-MM-y"
                    onChange={(dateValue) => onChange(dateValue)}
                    value={value}
                  />
                );
              case 'textarea':
                return (
                  <textarea
                    {...fieldProps}
                    {...commonProps}
                    onChange={onChange}
                  />
                );
              case 'file':
                return (
                  <div className="my-3">
                    <FilePicker 
                      onPick={(field,value) =>  setValue(field,value)}
                      loading={attachment.loading} />
                  </div>
                )
              case 'checkbox':
                return (
                  <div className={`form-check form-switch`}>
                    <input
                      className="form-check-input p-2" 
                      role="button"
                      size="lg"
                      type="checkbox"
                      onChange={onChange}
                      id="sendSMSCheckbox"
                      checked={value}
                      />
                    <label
                      className="form-check-label px-2"
                      htmlFor="sendSMSCheckbox">
                      Send SMS Notification
                    </label>
                {errors[field.name] && (
                  <div className="invalid-feedback d-block">
                    <i className="bi bi-patch-exclamation-fill me-2"></i>{errors[field.name].message}
                  </div>
                )}
                  </div>
                )
              case 'creatable':
                return null;
              case 'amount':
                return (
                  <input
                    {...fieldProps}
                    {...commonProps}
                    type="text"
                    value={formatMoney(value)}
                    onChange={(e) => amountChangeHandler(e, onChange)}
                  />)
              default:
                return (
                  <input
                    {...fieldProps}
                    {...commonProps}
                    type={field.type}
                    onChange={onChange}
                  />
                );
            }
          }}
        />
        {errors[field.name] && (
          <div className="invalid-feedback">{errors[field.name].message}</div>
        )}
      </div>
    );
  };

  // Render the form
  return (
    <form 
      onSubmit={handleSubmit(submitAddTransaction)} 
      id="newtxnform" className="row p-0">

      {formFields.map(renderField)}
      
      <div className="row my-3 sticky-bottom-drawer">
        <div className="col-md-6 d-grid mt-md-0">
          <button
            type="submit"
            className="btn btn-success block"
            disabled={attachment.loading || isSubmitting || !isValid}
            onClick={() => {
              setMultipler(1);
            }}
          >
            <b className="fs-5 text-uppercase"><span className="fs-4">+</span> You Received</b>
          </button>
        </div>
        <div className="col-md-6 d-grid mt-md-0">
          <button type="submit"
            className="btn btn-danger block py-3"
            disabled={attachment.loading || isSubmitting || !isValid}
            onClick={() => {
              setMultipler(-1);
            }}>
            <b className="fs-5 text-uppercase"><span className="fs-4">-</span> You Paid</b>
          </button>
        </div>
      </div>
      <br />
    </form>
  );
};

export default OneTimeTxn;